import { cva } from '@/styled-system/css';

export const textRecipe = cva({
  variants: {
    color: {
      'text.invisible': { color: 'transparent.invisible' },
      'text.neutral': { color: 'text.neutral' },
      'text.neutral-fixed': { color: 'text.neutral-fixed' },
      'text.subtle': { color: 'text.subtle' },
      'text.onImpact.neutral-fixed': { color: 'text.onImpact.neutral-fixed' },

      // Legacy values
      'transparent': { color: 'transparent.invisible' },
      'brand': { color: 'blue.400' },
      'brandSecondary': { color: 'yellow.400' },
      'textWhite': { color: 'text.onImpact.neutral-fixed' },
      'textLight': { color: 'gray.400' },
      'textMedium': { color: 'text.subtle' },
      'textDark': { color: 'text.neutral' },
    },
    textStyle: {
      'heading-xl': { textStyle: 'heading-xl' },
      'heading-lg': { textStyle: 'heading-lg' },
      'heading-md': { textStyle: 'heading-md' },
      'heading-sm': { textStyle: 'heading-sm' },
      'heading-xs': { textStyle: 'heading-xs' },
      'body-lg': { textStyle: 'body-lg' },
      'body-lg-bold': { textStyle: 'body-lg-bold' },
      'body': { textStyle: 'body' },
      'body-bold': { textStyle: 'body-bold' },
      'body-sm': { textStyle: 'body-sm' },
      'body-sm-bold': { textStyle: 'body-sm-bold' },
      'body-xs': { textStyle: 'body-xs' },
      'body-xs-bold': { textStyle: 'body-xs-bold' },
      'fineprint': { textStyle: 'fineprint' },
      'fineprint-bold': { textStyle: 'fineprint-bold' },
      'fineprint-sm': { textStyle: 'fineprint-sm' },
      'fineprint-sm-bold': { textStyle: 'fineprint-sm-bold' },
      'responsive.heading-xl': { textStyle: 'responsive.heading-xl' },
      'responsive.heading-lg': { textStyle: 'responsive.heading-lg' },
      'responsive.heading-md': { textStyle: 'responsive.heading-md' },
      'responsive.heading-sm': { textStyle: 'responsive.heading-sm' },
      'responsive.heading-xs': { textStyle: 'responsive.heading-xs' },
      'responsive.body-lg': { textStyle: 'responsive.body-lg' },
      'responsive.body-lg-bold': { textStyle: 'responsive.body-lg-bold' },
    },
  },
});
